import { $$ } from "@utils/dom";

import Module from "../module/Module";
import PbRowStackedFeatures from "./PbRowStackedFeatures";

export const SELECTOR = `[data-pb-row-stacked-features]`;

class Factory extends Module {
  constructor(init = false) {
    super();

    this.initialized = false;
    this.items = null;

    init ? this.init() : null;
  }

  get name() {
    return "PbRowStackedFeatures";
  }

  init() {
    // set initialized
    this.initialized = true;
    this.items = [...$$(SELECTOR)].map(el => new PbRowStackedFeatures(el, this.emitter));
  }

  destroy() {
    if (this.items) this.items.forEach(el => el.destroy());

    this.initialized = false;
    this.items = null;
  }

  stop() {
    if (this.items) this.items.forEach(el => el.stop());
  }
}

export default Factory;
